import type { TeamRole } from '../company/company-team-member.model';
import type { User } from './user';

/**
 * Resolves the acting user's intra-Company sub-role for R5 gating.
 *
 * When auth payloads omit `team_role`, defaults to `'owner'` so production
 * stays permissive until the backend returns the field. Do not flip this
 * default until Postman/OpenAPI and auth responses expose `team_role`.
 */
export function resolveUserTeamRole(user: User | null | undefined): TeamRole {
  return user?.team_role ?? 'owner';
}
